import { render, staticRenderFns } from "./schoolIndex.vue?vue&type=template&id=a7f21ad4&scoped=true"
import script from "./schoolIndex.vue?vue&type=script&lang=js"
export * from "./schoolIndex.vue?vue&type=script&lang=js"
import style0 from "./schoolIndex.vue?vue&type=style&index=0&id=a7f21ad4&prod&lang=scss&scoped=true"
import style1 from "./schoolIndex.vue?vue&type=style&index=1&id=a7f21ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f21ad4",
  null
  
)

export default component.exports